var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 0C6.94772 0 6.5 0.447716 6.5 1V6H1.5C0.947715 6 0.5 6.44772 0.5 7C0.5 7.55228 0.947716 8 1.5 8H6.5V13C6.5 13.5523 6.94772 14 7.5 14C8.05228 14 8.5 13.5523 8.5 13V8H13.5C14.0523 8 14.5 7.55228 14.5 7C14.5 6.44772 14.0523 6 13.5 6H8.5V1C8.5 0.447715 8.05228 0 7.5 0Z","fill":"white"}));
}

PlusSign.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
